import { Dialog, Divider, useMediaQuery } from "@material-ui/core";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "styled-components/macro";
import { useNavigate } from "react-router-dom";
import Check from "../../../../components/Checkbox/Checkbox";
import { Button } from "../../../../components/Button/Button";
import { useInitiateProposalMutation } from "../../../../services/ProposalServices";
import { setShowPaDialog } from "../../QuotesPage.slice";
import {
  setSelectedAddons,
  removeAddon,
  selectedAddonsSelector,
} from "../../QuotesPage.slice";
import {
  CloseButton,
  DialogTitle,
} from "../EditDetailsDialog/EditDetailsDialog.style";
import { Close } from "@material-ui/icons";

const PaDialog = () => {
  const { showPaDialog, selectedQuoteDetails } = useSelector(
    (state) => state.quotes
  );
  const addons = useSelector(selectedAddonsSelector);
  const dispatch = useDispatch();

  const fullScreen = useMediaQuery("(max-width:576px)");
  const [check1, setCheck1] = useState(false);
  const [check2, setCheck2] = useState(false);
  const { initiateProposal, isSubmitting } = useInitiateProposalMutation();

  const handlePaCoverChange = () => {
    const paCoverSelected = addons.includes("PA_COVER");
    if (paCoverSelected) {
      dispatch(removeAddon("PA_COVER"));
    } else {
      dispatch(setSelectedAddons("PA_COVER"));
      setCheck1(false);
      setCheck2(false);
    }
  };

  const onClose = () => {
    dispatch(setShowPaDialog(false));
  };

  const disablePaCover = check1 || check2;
  const disableOtherChecks = addons.includes("PA_COVER");

  return (
    <>
      <Dialog
        open={showPaDialog}
        onClose={onClose}
        fullWidth
        maxWidth={"xs"}
        disableEnforceFocus
        fullScreen={fullScreen}
      >
        <DialogTitle
          css={`
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px 20px;
          `}
        >
          <div
            css={`
              font-size: 16px;
              font-weight: 600;
            `}
          >
            Personal Accident Cover is Mandatory as per IRDAI
          </div>
          <CloseButton onClick={onClose}>
            <Close />
          </CloseButton>
        </DialogTitle>

        <Divider />

        <div
          css={`
            padding: 20px;
          `}
        >
          <div
            css={`
              margin-bottom: 16px;
            `}
          >
            <Check
              label="Personal Accident Cover"
              checked={addons.includes("PA_COVER")}
              disabled={disablePaCover}
              onClick={handlePaCoverChange}
            />
          </div>

          <div
            css={`
              color: var(--primary-color);
              margin-bottom: 16px;
              font-weight: 500;
            `}
          >
            You can only opt out if:
          </div>

          <div
            css={`
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              gap: 8px;
            `}
          >
            <Check
              label="The owner does not have driving license"
              checked={check1}
              disabled={disableOtherChecks}
              onClick={() => {
                const newVal = !check1;
                setCheck1(newVal);
                if (newVal) {
                  setCheck2(false);
                  dispatch(removeAddon("PA_COVER"));
                }
              }}
            />

            <div
              css={`
                font-weight: 500;
                align-self: center;
              `}
            >
              OR
            </div>

            <Check
              label="Owner already has PA cover of at least 15 lacs"
              checked={check2}
              disabled={disableOtherChecks}
              onClick={() => {
                const newVal = !check2;
                setCheck2(newVal);
                if (newVal) {
                  setCheck1(false);
                  dispatch(removeAddon("PA_COVER"));
                }
              }}
            />
          </div>

          {(check1 || check2 || addons.includes("PA_COVER")) && (
            <div
              css={`
                display: flex;
                justify-content: center;
                margin-top: 24px;
              `}
            >
              <Button
                onClick={() => {
                  initiateProposal(selectedQuoteDetails);
                  dispatch(setShowPaDialog(false));
                }}
                primary
                css={`
                  width: 120px;
                  text-align: center;
                  padding: 12px 0;
                `}
              >
                Proceed
              </Button>
            </div>
          )}
        </div>
      </Dialog>
    </>
  );
};

export default PaDialog;
